var Breadcrumbs = (props)=>{
    if (!props.crumbs||props.crumbs.length<2) return null;
    return <div style={{opacity:0.7,marginBottom:"1em"}}>{props.crumbs.map((crumb,idx)=>(<span key={idx}>{idx>0?"/ ":""}<a href={crumb.link}>{crumb.name}</a> </span>))}</div>
}

export default Breadcrumbs 